import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { fetchFooter } from "../../services/api";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import ParticleFooter from "./particles";

const Footer = () => {
  const [content, setContent] = useState(null);

  const location = useLocation();
  const lang = location.pathname.startsWith("/ja") ? "ja" : "en";

  useEffect(() => {
    fetchFooter(lang).then(setContent);
  }, [lang]);

  if (!content) return <p className="p-6">Loading...</p>;
  return (
    <section
      className="relative overflow-hidden w-full footer"
      style={{ backgroundColor: "rgba(0, 64, 152, 1)", background: "linear-gradient(315deg, #022a60 0%,#004098 30%,#096af1 50%, #004098 70%,#022a60 100%)" }}
    >
      {/* Particle background */}
      <ParticleFooter />

      {/* Lottie circle — desktop: large right side | mobile: small top-right */}
      <div
        className="absolute pointer-events-none"
        style={{ right: "0%", top: "0%", zIndex: 10 }}
      >
        {/* Desktop */}
        <div
          className="hidden lg:block"
          style={{
            width: "610px",
            minWidth: "610px",
            height: "610px",
            position: "absolute",
            right: 0,
            transform: " translate(30%, -10%)",
          }}
        >
          <DotLottieReact
            src="../../../lottie-files/footer-animation-motif.lottie"
            loop
            autoplay
            style={{ width: "680px", height: "680px", display: "block" }}
          />
        </div>

        {/* Mobile */}
        <div
          className="block lg:hidden"
          style={{ width: "200px", minWidth: "200px", height: "200px", transform: " translate(40%, -40%)", }}
        >
          <DotLottieReact
            src="../../../lottie-files/footer-animation-motif.lottie"
            loop
            autoplay
            style={{ width: "200px", height: "200px", display: "block" }}
          />
        </div>
      </div>

      {/* Content */}
      <div className="relative z-20 padding-x-40 padding-y-80" style={{ pointerEvents: "none" }}>

        {/* ── DESKTOP (md and above) ── */}
        <div
          className="hidden md:flex flex-col justify-between "

        >
          {/* Heading */}
          <h1 className="text-white size-h3" dangerouslySetInnerHTML={{ __html: content?.footer_heading }}>


          </h1>

          {/* Bottom bar */}
          <div className="flex flex-row justify-between items-center pt-10">

            {/* Left: copyright + links */}
            <div className="flex flex-row items-center gap-6 text-white text-sm">
              <span>{content?.copyright_text}</span>
              <a
                href={content?.dataprotection_url?.startsWith("http") ? content?.dataprotection_url : `https://${content?.dataprotection_url}`}
                target="_blank" rel="noreferrer"
                className="hover:underline fs-10"
                style={{ pointerEvents: "auto" }}
              >
                {content?.data_protection_text}
              </a>
              {content?.privacy_policy_url && (
                <a
                  href={content?.privacy_policy_url?.startsWith("http") ? content?.privacy_policy_url : `https://${content?.privacy_policy_url}`}
                  target="_blank" rel="noreferrer"
                  className="hover:underline fs-10"
                  style={{ pointerEvents: "auto" }}
                >
                  {content?.privacy_policy_text}
                </a>
              )}
                <a
                href='https://saison-capital.staginggportals.com/uploads/cookies_policy_bac2ec27fc.pdf'
                target="_blank" rel="noreferrer"
                className="hover:underline fs-10"
                style={{ pointerEvents: "auto" }}
              >
                Cookies Policy
              </a>
            </div>

            {/* Right: Follow us + LinkedIn */}
            <div
              className="flex flex-row items-baseline gap-3 text-white text-sm"
              style={{ pointerEvents: "auto" }}
            >
              <span className="uppercase font-light tracking-wide fs-10">
                {content?.Follow_us_text}
              </span>
              <a href={content?.linked_in_url?.startsWith("http") ? content?.linked_in_url : `https://${content?.linked_in_url}`}
                target="_blank" rel="noreferrer"
                className="hover:underline" dangerouslySetInnerHTML={{ __html: content?.svg_linkedin }} />
            </div>
          </div>
        </div>

        {/* ── MOBILE (below md) ── */}
        <div className="flex md:hidden flex-col ">

          {/* Heading */}
          <h1 className="text-white text-2xl font-semibold mb-10 md:mb-8" style={{ maxWidth: "65%" }}
            dangerouslySetInnerHTML={{ __html: content?.footer_heading }}>
          </h1>

          {/* Follow us + LinkedIn */}
          <div
            className="flex flex-row items-baseline gap-3 text-white text-sm mt-5  md:mt-0  mb-4"
            style={{ pointerEvents: "auto" }}
          >
            <span className="uppercase font-light tracking-widest text-xs">
              {content?.Follow_us_text}
            </span>
            <a href={content?.linked_in_url?.startsWith("http") ? content?.linked_in_url : `https://${content?.linked_in_url}`}
              target="_blank" rel="noreferrer"
              className="hover:underline" dangerouslySetInnerHTML={{ __html: content?.svg_linkedin }} />
          </div>

          {/* Divider */}
          <div className="w-full border-t border-white mb-4" style={{ opacity: 0.4 }} />

          {/* Copyright */}
          <p className="text-white text-sm mb-3">{content?.copyright_text}</p>

          {/* Links */}
          <div
            className="flex flex-row items-center gap-6 text-white text-sm"
            style={{ pointerEvents: "auto" }}
          >
            <a
              href={content?.dataprotection_url?.startsWith("http") ? content?.dataprotection_url : `https://${content?.dataprotection_url}`}
              target="_blank" rel="noreferrer"
              className="hover:underline fs-10"
            >
              {content?.data_protection_text}
            </a>
            {content?.privacy_policy_url && (
              <a
                href={content?.privacy_policy_url?.startsWith("http") ? content?.privacy_policy_url : `https://${content?.privacy_policy_url}`}
                target="_blank" rel="noreferrer"
                className="hover:underline fs-10"
              >
                {content?.privacy_policy_text}
              </a>

              
            )}
             <a
                href='https://saison-capital.staginggportals.com/uploads/cookies_policy_bac2ec27fc.pdf'
                target="_blank" rel="noreferrer"
                className="hover:underline fs-10"
              >
                Cookies Policy
              </a>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Footer;